module.exports = __webpack_public_path__ + "img/left-base.78e8071f.png";